import { setIsFocusedInboxCapableService } from "../services/setIsFocusedCapableService";
import { initializeAlwaysInCacheTableViews } from "owa-mail-triage-local-updates/lib/actions/tableCache/alwaysInCacheTableViews";
import { loadDefaultTable } from "owa-mail-table-loading-actions/lib/actions/loadDefaultTable";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";
import { updateAccountScopeUserSettingsAndService } from "owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService";
import { getSelectedTableView } from "owa-mail-list-store";
import { setLastAutoFocusedRowKey } from "owa-mail-list-selection-actions-v2";
import { resetFocus } from "owa-mail-focus-manager/lib/mailModuleAutoFocusManager";
import { isSameCoprincipalAccountMailboxInfos, type MailboxInfo } from "owa-client-types";
import { getMailboxInfo } from "owa-mail-mailboxinfo";

/**
 * Set Focused inbox On/Off
 * @param isFocusedInboxEnabled - Switch flag to indicate if Focused Inbox should be switched On/Off
 * @param skipServiceRequest - Whether to skip the service request to save the setting. Used when called as part of Options stitch
 * @param mailboxInfo - Mailbox whose Focused Inbox setting should be updated
 */
export default function setFocusedInboxOnOff(isFocusedInboxEnabled: boolean | null, skipServiceRequest: boolean, mailboxInfo: MailboxInfo): void {
    const selectedTableView = getSelectedTableView();
    
    // Update the account setting before reloading the table query.
    if (!skipServiceRequest) {
        updateAccountScopeUserSettingsAndService(mailboxInfo, {
            UserOptions: {
                IsFocusedInboxEnabled: isFocusedInboxEnabled === null ? undefined : isFocusedInboxEnabled,
            },
        });
    }
    
    // Reload selected table only if it is Inbox in default query as per focused config
    if (selectedTableView &&
        folderIdToName(selectedTableView.tableQuery.folderId ?? "") === "inbox" &&
        isSameCoprincipalAccountMailboxInfos(getMailboxInfo(selectedTableView), mailboxInfo)) {
        loadDefaultTable(mailboxInfo);
        
        // Resets focus to ML content and clears last focused row key (since
        // the table is being reloaded) so that user can tab through the ML
        // and have focus land on a row.
        resetFocus("FocusedOther_Toggled");
        setTimeout(() => {
            setLastAutoFocusedRowKey(selectedTableView, "");
        }, 0);
    }
    
    // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
    if (!skipServiceRequest && isFocusedInboxEnabled) {
        setIsFocusedInboxCapableService(mailboxInfo);
    }
    initializeAlwaysInCacheTableViews(mailboxInfo);
}
